import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import ModalWrapper from "../Shared/Modal";
import { setShowSearchModal } from "../../redux/slices/searchSlice";
import SearchResults from "./SearchResults";
import { debounce } from "lodash";
import { validateSearchInput } from "../../helpers";
import { BackspaceRounded } from "@mui/icons-material";

const SearchModal = () => {
  const [inputValue, setInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const { showSearchModal } = useSelector((state: RootState) => state.search);
  const dispatch = useDispatch<AppDispatch>();
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const debounceSearchTerm = debounce(() => {
      setSearchTerm(inputValue);
    }, 300);

    debounceSearchTerm();

    return () => {
      debounceSearchTerm.cancel();
    };
  }, [inputValue]);

  // get error type if search term don't fulfill criterias
  const errorType = useMemo(() => (
    searchTerm.length > 0 ? validateSearchInput(searchTerm) : null
  ), [searchTerm]);

  return (
    <ModalWrapper open={showSearchModal} handleClose={() => dispatch(setShowSearchModal(false))} blurBackdrop>
      <div className="flex flex-col gap-y-2">
        <div>
          <TextField
            inputRef={inputRef}
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            type="text"
            placeholder="Search your chats..."
            className="search-input !bg-[rgb(245,247,248)] dark:!bg-[rgb(33,34,35)] !rounded-lg"
            variant="outlined"
            fullWidth
            autoComplete="off"
            autoFocus
            onFocus={() => {
              const el = inputRef.current;
              if (el) {
                requestAnimationFrame(() => {
                  const length = el.value.length;
                  el.setSelectionRange(length, length);
                  el.scrollLeft = el.scrollWidth;
                });
              }
            }}
            InputProps={{
              endAdornment: inputValue.length > 0 && (
                <InputAdornment position="end">
                  <IconButton onClick={() => setInputValue("")}>
                    <BackspaceRounded className="!w-4 !h-4 !fill-action-disabled" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ ".MuiOutlinedInput-root": {
              color: "white",
            } }}
          />
        </div>
        <section>
          <SearchResults searchQuery={searchTerm} errorType={errorType} />
        </section>
      </div>
    </ModalWrapper>
  );
};

export default SearchModal;
